<script setup lang="ts">
    import { reactive, defineProps, defineEmits } from 'vue';
    import { markAccountForDeletion } from '@cwd/Views/BackOffice/Account/Account.access';
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import { bsAlert } from '@shared/components/BsAlerts';
    import { useRouter } from 'vue-router';

    const props = defineProps<{
        accountId: string;
        isDeleted: boolean;
    }>();

    const emit = defineEmits(['accountDeleted']);

    const state = reactive<{
        retention: number;
        isLoading: boolean;
    }>({
        retention: 180,
        isLoading: false,
    });

    const router = useRouter();

    async function deleteAccount() {
        state.isLoading = true;
        await markAccountForDeletion(props.accountId, state.retention)
            .then(() => {
                emit('accountDeleted');
                router.push({ name: 'AccountList' });
                bsAlert({ title: 'Deleted', content: 'Account marked for deletion', type: 'success' });
            })
            .catch(() => {
                bsAlert({ title: 'Error', content: 'Something went wrong', type: 'danger' });
            })
            .finally(() => {
                state.isLoading = false;
            });
    }
</script>

<template>
    <div class="alert alert-info alert-fixed-i m-xs-b" v-if="props.isDeleted">
        <p>
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            This account has been marked for deletion
        </p>
    </div>
    <div class="ug-form-group-2" v-if="!props.isDeleted">
        <BSFormInputText class="form-group" v-model="state.retention" :label="'Days before actual removal'" :type="'number'"></BSFormInputText>
        <button class="btn btn-danger" v-confirm="{ action: () => deleteAccount() }">Mark account for deletion</button>
    </div>
</template>

<style scoped>
    .ug-form-group-2 {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
</style>
